/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Lede_2Inputs */

const en_home_hero_lede_2 = /** @type {(inputs: Home_Hero_Lede_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put a team of agents on research, or on a whole process,`)
};

const lv_home_hero_lede_2 = /** @type {(inputs: Home_Hero_Lede_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzticiet izpēti vai visu procesu AI aģentu komandai,`)
};

/**
* | output |
* | --- |
* | "Put a team of agents on research, or on a whole process," |
*
* @param {Home_Hero_Lede_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_hero_lede_2 = /** @type {((inputs?: Home_Hero_Lede_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Lede_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_hero_lede_2(inputs)
	return en_home_hero_lede_2(inputs)
});